import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from './BaseComponent';
import { answerStatusTypes } from '../../Constants';

class Popup extends BaseComponent {
    constructor(props) {
        super(props);

        this.handleClickPopup = this.handleClickPopup.bind(this);
    }

    createPopupClassName() {
        return `${this.Styles.popup} ${this.props.answerStatus}`;
    }

    renderText() {
        let text = '';

        if (this.props.answerStatus === answerStatusTypes.CORRECT) {
            text = this.getLang('Msgs.quiz_correct');
        } else if (this.props.answerStatus === answerStatusTypes.INCORRECT) {
            text = this.getLang('Msgs.quiz_incorrect');
        }

        return text;
    }

    handleClickPopup() {
        this.props.onClickPopup(this.props.answerStatus);
    }

    render() {
        return (
            <div
                onClick={this.handleClickPopup}
                className={this.createPopupClassName()}
            >
                <div className={this.Styles.popupImage}>
                    <div className={this.Styles.popupText}>
                        {this.renderText()}
                    </div>
                </div>
            </div>
        );
    }
}

Popup.displayName = 'Popup';
Popup.propTypes = {
    answerStatus: PropTypes.oneOf(Object.keys(answerStatusTypes)),
    onClickPopup: PropTypes.func.isRequired,
};

export default Popup;



// WEBPACK FOOTER //
// ./components/QuizSet/Popup.js